import React, {useState, useEffect, useRef} from "react";
import {useSelector, useDispatch} from "react-redux";
import {Table, Row, Col, Modal, ModalHeader, ModalBody, Tooltip, UncontrolledTooltip} from 'reactstrap';
import Lottie from 'react-lottie-player';
import {v4 as uuidv4} from 'uuid';
import {
  getResourceMappingConfig,
  postResourceMappingConfig,
  deleteResourceMappingConfig,
  updateResourceMappingConfig, postUpdateSuggestedMappings, applyMappingConfig
} from "../../store/actions";
import Select from 'react-select';
import {
  getServices as onGetServices,
  getSuggestedMappings as onGetSuggestedMappings

} from "../../store/actions";
import Card from "components/PurpleTheme/Card";
import dragAndDrop from "../../assets/images/drag-and-drop.json"
import {Link} from "react-router-dom";

const OrganizationServiceMapping = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [serviceNames, setServiceNames] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [btnHover, setBtnHover] = useState(false);
  const [type, setType] = useState(null);
  const [autoMappingType, setAutoMappingType] = useState(null);
  const [textMatchType, setTextMatchType] = useState(null);
  const [selectedEnv, setSelectedEnv] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editmode, setEditMode] = useState(false);
  const [dataToMap, setDataToMap] = useState([]);
  const [addMode, setAddMode] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [keyInput, setKeyInput] = useState('');
  const [valueInput, setValueInput] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [draggingCardId, setDraggingCardId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [hover, setHover] = useState(null);
  const [showPrecedence, setShowPrecedence] = useState(false);
  const [allowDrag, setAllowDrag] = useState(false);
  const [overrideChecked, setOverrideChecked] = useState(false);
  const [caseInSensitiveChecked, setCaseInSensitiveChecked] = useState(true);
  const [dataToMapEnv, setDataToMapEnv] = useState(null);
  const [dataToMapService, setDataToMapService] = useState(null)
  const nameRef = useRef();
  const keyRef = useRef();
  const valueRef = useRef();
  const newItemRef = useRef(null);
  const [addedMapping, setAddedMapping] = useState(false);
  const [sink, setSink] = useState(false);

  const {mapped_services} = useSelector(state => ({
    mapped_services: state.Organization.mapped_services || [],
  }));

  const {suggested_mappings} = useSelector(state => ({
    suggested_mappings: state.Organization.suggested_mappings || [],
  }));

  let environments = [
    {value: 'PRODUCTION', label: 'PRODUCTION'},
    {value: 'UAT', label: 'UAT'},
    {value: 'STAGING', label: 'STAGING'},
    {value: 'PREPROD', label: 'PREPROD'},
    {value: 'DEV', label: 'DEV'},
    {value: 'OTHER', label: 'OTHER'},]

  let match_options = [
    {value: "BEGINS_WITH", label: "Starts with"},
    {value: "ENDS_WITH", label: "Ends with"},
    {value: "EXACT_MATCH", label: "Exact match"},
    {value: "CONTAINS", label: "Contains"}
  ]

  let autoMappingOptions = [
    {value: "Environment", label: "Environment"},
    {value: "ApplicationService", label: "ApplicationService"}
  ]
  const services = useSelector(state =>
    state.Service.services
  );

  useEffect(() => {
    dispatch(onGetServices())
    dispatch(onGetSuggestedMappings())
  }, [onGetServices, isOpen])

  useEffect(() => {
    dispatch(getResourceMappingConfig())
  }, [getResourceMappingConfig])

  useEffect(() => {
    const envData = [];
    const serviceData = [];
    if (!editmode && !addMode) {
      mapped_services.filter(item => item.auto_mapping === 'Environment').map((item, index) => (
        envData.push({
          mapping_type: item.mapping_type,
          tag_key: item.tag_key,
          tag_value: item.tag_value,
          name_pattern: item.name_pattern,
          matching_pattern: item.matching_pattern,
          mapping_id: item.id,
          environment: item.environment,
          precedence: item.precedence,
          override_existing_mapping: item.override_existing_mapping,
          auto_mapping: item.auto_mapping
        })
      ))
      mapped_services.filter(item => item.auto_mapping === 'ApplicationService').map((item, index) => (
        serviceData.push({
          application_service_id: item.application_service_id,
          mapping_type: item.mapping_type,
          tag_key: item.tag_key,
          tag_value: item.tag_value,
          name_pattern: item.name_pattern,
          matching_pattern: item.matching_pattern,
          mapping_id: item.id,
          precedence: item.precedence,
          override_existing_mapping: item.override_existing_mapping,
          auto_mapping: item.auto_mapping
        })
      ))

      setDataToMapEnv(envData);
      setDataToMapService(serviceData);
    }
  }, [mapped_services])

  const resetDataToMap = () => {
    const envData = [];
    const serviceData = [];
    mapped_services.filter(item => item.auto_mapping === 'Environment').map((item, index) => (
      envData.push({
        mapping_type: item.mapping_type,
        tag_key: item.tag_key,
        tag_value: item.tag_value,
        name_pattern: item.name_pattern,
        matching_pattern: item.matching_pattern,
        mapping_id: item.id,
        environment: item.environment,
        precedence: item.precedence,
        override_existing_mapping: item.override_existing_mapping,
        auto_mapping: item.auto_mapping
      })
    ))
    mapped_services.filter(item => item.auto_mapping === 'ApplicationService').map((item, index) => (
      serviceData.push({
        application_service_id: item.application_service_id,
        mapping_type: item.mapping_type,
        tag_key: item.tag_key,
        tag_value: item.tag_value,
        name_pattern: item.name_pattern,
        matching_pattern: item.matching_pattern,
        mapping_id: item.id,
        precedence: item.precedence,
        override_existing_mapping: item.override_existing_mapping,
        auto_mapping: item.auto_mapping
      })
    ))

    setDataToMapEnv(envData);
    setDataToMapService(serviceData);
  }

  useEffect(() => {
    const allNames = {};
    const options = services?.map((service) => ({
      value: service.id,
      label: service.name
    }));
    services?.forEach(element => {
      allNames[element.id] = element.name
    });
    setServiceNames(allNames);
    setServiceOptions(options);
  }, [services])

  const toggle = () => {
    if (isOpen === true) {
      setType(null);
      setEditMode(false)
    }
    setIsOpen(!isOpen)
  }

  const clearInputs = () => {
    setType(null);
    if (keyRef.current) keyRef.current.value = '';
    if (valueRef.current) valueRef.current.value = '';
    if (nameRef.current) nameRef.current.value = '';
    setNameInput('');
    setKeyInput('');
    setValueInput('');
    setSelectedEnv(null);
    setTextMatchType(null);
    setSelectedService(null);
    setOverrideChecked(false);
    setCaseInSensitiveChecked(true);
    setAutoMappingType({value: 'ApplicationService', label: 'ApplicationService'});
  }

  const handleAdd = () => {
    clearInputs();
    setIsOpen(true);
    setAddMode(true);
  }

  const customOptionRenderer = (option) => {
    if (option.value === "/add-service") {
      return (
        <div
          className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{cursor: "pointer"}}>
          <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`}/>
          <span>
            {option.label}
          </span>

        </div>
      );
    } else {
      return option.label;
    }
  };

  const loadData = () => {
    setLoading(true)
    setTimeout(() => {
      dispatch(getResourceMappingConfig())
      setLoading(false);
    }, 1000)
    setEditMode(false);
    setAddMode(false);
    clearInputs();
  }


  const handleMap = () => {
    dispatch(postResourceMappingConfig({"mappings": [...dataToMapEnv, ...dataToMapService]}));
    setIsOpen(false);
    loadData();
  };


  const handleItemAdd = () => {
    setEditMode(false);
    setAddMode(true);
    let newMapping = {};
    const tagKey = keyRef.current?.value?.trim() || '';
    const tagValue = valueRef.current?.value?.trim() || '';
    const namePattern = nameRef.current?.value?.trim() || '';

    const uniqueId = uuidv4();

    if (type === 'TAG_BASED' && tagKey !== "" && tagValue !== "") {
      newMapping = {
        'mapping_type': type,
        'tag_key': tagKey,
        'tag_value': tagValue,
        'application_service_id': selectedService?.value,
        'environment': selectedEnv?.value,
        'id_to_del': uniqueId,
        'override_existing_mapping': overrideChecked,
        'auto_mapping': autoMappingType?.value,
        'case_insensitive': caseInSensitiveChecked
      };
    } else if (type === 'NAME_BASED' && namePattern !== "") {
      newMapping = {
        'mapping_type': type,
        'name_pattern': namePattern,
        'matching_pattern': textMatchType.value,
        'application_service_id': selectedService?.value,
        'environment': selectedEnv?.value,
        'id_to_del': uniqueId,
        'override_existing_mapping': overrideChecked,
        'auto_mapping': autoMappingType?.value,
        'case_insensitive': caseInSensitiveChecked
      };
    }
    setIsOpen(false)

    if (Object.keys(newMapping).length > 0) {
      if (newMapping.auto_mapping === 'Environment') {
        const updatedDataToMap = [
          ...dataToMapEnv,
          newMapping
        ]
        setDataToMapEnv(updatedDataToMap)
      } else {
        const updatedDataToMap = [
          ...dataToMapService,
          newMapping
        ]
        setDataToMapService(updatedDataToMap);
      }
      clearInputs()
    }
    if (newItemRef.current) {
      newItemRef.current.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
    setTooltipOpen(true)
    setTimeout(() => {
      setTooltipOpen(false);
    }, 3000)
    setEditMode(false);
  };

  const customStyles = {
    width: '100%',
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position: "relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position: "relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200,
      // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position: "relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  const showDeleteModal = (data) => {
    setDeleteModal(true);
    setItemToDelete(data);
  }

  const handleCancelDelete = () => {
    setDeleteModal(false);
    setItemToDelete(null);
  }

  const handleDelete = () => {
    if (itemToDelete.mapping_id === undefined) {
      const updatedData = (itemToDelete.auto_mapping === 'Environment'
        ? dataToMapEnv
        : itemToDelete.auto_mapping === 'ApplicationService' ? dataToMapService : null).filter((item) => item.id_to_del !== itemToDelete.id_to_del);

      if (itemToDelete.auto_mapping === 'Environment') {
        setDataToMapEnv(updatedData);
      } else {
        setDataToMapService(updatedData);
      }
    } else {
      dispatch(deleteResourceMappingConfig({mapping_id: itemToDelete.mapping_id}));
      loadData();
    }
    setDeleteModal(false);
  };


  const showEditModal = (data) => {
    setItemToEdit(data)
    setEditMode(true);
    setType(data.mapping_type);
    setOverrideChecked(data.override_existing_mapping)
    setCaseInSensitiveChecked(data.case_insensitive)
    const selectedMatchOption = match_options?.find(option => option.value === data.matching_pattern);
    const selectedEnvOption = environments.find(option => option.value === data.environment);
    const selectedServiceOption = serviceOptions.find(option => option.value === data.application_service_id);
    const selectedAutoMapping = autoMappingOptions.find(option => option.value === data.auto_mapping)

    setTextMatchType(selectedMatchOption || null);
    setSelectedEnv(selectedEnvOption || null);
    setSelectedService(selectedServiceOption || null);
    setAutoMappingType(selectedAutoMapping || null);
    setIsOpen(true);
  }
  const [reorderedMappings, setReorderedMappings] = useState(suggested_mappings || []);

  const onApproveSuggestion = (data) => {
    const payload = {
      suggestion_id: data.suggestion_id,
      is_suggestion_accepted: data.is_suggestion_accepted
    }
    dispatch(postUpdateSuggestedMappings(payload));
  }

  const onIgnoreSuggestion = (data) => {
    const payload = {
      suggestion_id: data.suggestion_id,
      is_suggestion_accepted: data.is_suggestion_accepted
    }
    dispatch(postUpdateSuggestedMappings(payload));
  }

  useEffect(() => {
    const updatedMappings = [...suggested_mappings];

    const [accepted, rejected] = updatedMappings.reduce(
      ([accepted, rejected], mapping) => {
        if (mapping.is_suggestion_accepted === 'REJECTED') {
          return [accepted, [...rejected, mapping]];
        } else {
          return [[...accepted, mapping], rejected];
        }
      },
      [[], []]
    );

    const reorderedMappings = [...accepted, ...rejected];
    setReorderedMappings(reorderedMappings);
  }, [suggested_mappings]);

  const handleEdit = () => {
    const updatedItem = {
      ...itemToEdit,
      matching_pattern: textMatchType?.value || itemToEdit.matching_pattern || null,
      service_id: selectedService?.value || itemToEdit.application_service_id,
      environment: selectedEnv?.value || itemToEdit.environment,
      override_existing_mapping: overrideChecked,
      case_insensitive: caseInSensitiveChecked,
      id_to_del: itemToEdit.id_to_del || null,
      auto_mapping: itemToEdit.auto_mapping,
      id_to_edit: itemToEdit.id_to_edit
    };

    if (updatedItem.mapping_id !== undefined || updatedItem.id !== undefined) {
      dispatch(updateResourceMappingConfig(updatedItem));
      loadData();
    } else {
      if (addMode && editmode) {
        if (updatedItem.id_to_edit !== undefined) {
          const updatedData =
            (updatedItem.auto_mapping === 'Environment' ? dataToMapEnv
              : updatedItem.auto_mapping === 'ApplicationService' ? dataToMapService : null).map((item, index) =>
              index === updatedItem.id_to_edit ? updatedItem : item
            );
          if (updatedItem.auto_mapping === 'Environment') {
            setDataToMapEnv(updatedData);
          } else if (updatedItem.auto_mapping === 'ApplicationService') {
            setDataToMapService(updatedData)
          }
        } else {
          if (updatedItem.auto_mapping === 'Environment') {
            const updatedData = [...dataToMapEnv, updatedItem];
            setDataToMapEnv(updatedData);
          } else if (updatedItem.auto_mapping === 'ApplicationService') {
            const updatedData = [...dataToMapService, updatedItem];
            setDataToMapService(updatedData);
          }
        }
      }
      setEditMode(false);
    }
    setIsOpen(false);
    setType(null);
    clearInputs();
  };


  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDragStart = (e, id) => {
    e.dataTransfer.setData("text/plain", id);
    setDraggingCardId(id);
    setAddMode(true);
    setShowPrecedence(true)
    setTimeout(() => {
      setShowPrecedence(false)
    }, 2000)
  };

  const onDrop = (e, id, auto_mapping) => {
    e.preventDefault();

    const draggedCardId = e.dataTransfer.getData("text/plain");
    if (!draggedCardId || !id) return;

    if (auto_mapping === 'Environment') {
      const draggedCardIndex = dataToMapEnv.findIndex(card => `${card.mapping_id || card.id || card.id_to_del}index` === draggedCardId);
      const targetCardIndex = dataToMapEnv.findIndex(card => `${card.mapping_id || card.id || card.id_to_del}index` === id);

      if (draggedCardIndex === -1 || targetCardIndex === -1) return;

      const newCards = [...dataToMapEnv];
      const [draggedCard] = newCards.splice(draggedCardIndex, 1);
      newCards.splice(targetCardIndex, 0, draggedCard);

      const updatedCards = newCards.map((card, index) => ({
        ...card,
        precedence: index,
      }));

      setDataToMapEnv(updatedCards);
    } else if (auto_mapping === 'ApplicationService') {
      const draggedCardIndex = dataToMapService.findIndex(card => `${card.mapping_id || card.id || card.id_to_del}index` === draggedCardId);
      const targetCardIndex = dataToMapService.findIndex(card => `${card.mapping_id || card.id || card.id_to_del}index` === id);

      if (draggedCardIndex === -1 || targetCardIndex === -1) return;

      const newCards = [...dataToMapService];
      const [draggedCard] = newCards.splice(draggedCardIndex, 1);
      newCards.splice(targetCardIndex, 0, draggedCard);

      const updatedCards = newCards.map((card, index) => ({
        ...card,
        precedence: index,
      }));

      setDataToMapService(updatedCards);

    }
    setHover(null);
    setDraggingCardId(null);
    setShowPrecedence(true)
    setTimeout(() => {
      setShowPrecedence(false)
    }, 2000)
  };

  const isSaveButtonDisabled = () => {
    let isServiceOrEnvPopulated = false
    if (autoMappingType && autoMappingType.value === 'ApplicationService') {
      isServiceOrEnvPopulated = selectedService !== null;
    }
    if (autoMappingType && autoMappingType.value === 'Environment') {
      isServiceOrEnvPopulated = selectedEnv !== null;
    }
    if (type === 'TAG_BASED') {
      return valueInput.trim() === '' || keyInput.trim() === '' || !isServiceOrEnvPopulated || autoMappingType === null;
    } else if (type === 'NAME_BASED') {
      return nameInput.trim() === '' || !isServiceOrEnvPopulated || textMatchType === null || autoMappingType === null;
    }
    return true;
  };

  useEffect(() => {
    window.onload = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('tab') === '5') {
        const accordionElement = document.getElementById('environmentAccordion');
        if (accordionElement) {
          setTimeout(() => {
            accordionElement.scrollIntoView({behavior: 'smooth', block: 'start'});
          }, 100);
        }
      }
    };
  }, []);


  function handleClickApplyConfig() {
    dispatch(applyMappingConfig());
  }

  return (
    <React.Fragment>
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} autoFocus={true} centered={true} size={`${editmode ? 'sm' : 'md'}`}>
        <ModalBody>
          <div>
            <div className="d-flex justify-content-center">
              <span className="font-size-18 my-4 text-white">Are you sure you want to delete this mapping?</span>
            </div>
            <div className="d-flex justify-content-center gap-4">
              <button onClick={handleDelete} className="btn btn-primary bg-danger border border-0">Yes</button>
              <button onClick={() => handleCancelDelete()} className="btn btn-primary bg-primary">Cancel</button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={true}
        centered={true}
        size={`lg`}>
        <ModalHeader className={`d-flex ${editmode ? 'justify-content-center' : ''}`}>
          <div className="w-100 text-center d-flex justify-content-center">
            {editmode ? 'Edit Mapping' : 'Add new'}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="w-full d-flex flex-column justify-content-center">

            {(!editmode) ?
              <div className="d-flex w-100 gap-3 align-items-center mb-4">
                <div className="d-flex align-items-center w-100 gap-3">
                  <div className="w-100">
                    <Select
                      isClearable
                      options={[
                        {value: "TAG_BASED", label: "Tag based"},
                        {value: "NAME_BASED", label: "Name based"}
                      ]}
                      placeholder="Select Mapping Type"
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setType(selectedOption.value)
                        } else {
                          setType(null);
                        }
                      }}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                    />
                  </div>

                </div>

                {type === null ? <button className="btn btn-secondary" onClick={() => setIsOpen(false)}>Cancel</button> : null}
              </div> : null
            }
            <div className="w-100 d-flex gap-3 align-items-start justify-content-start">
              {type === 'TAG_BASED' ?
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <span> If <b className="text-white">KEY</b> is</span>
                  <div>
                    <input
                      ref={keyRef}
                      value={editmode ? itemToEdit.tag_key : keyInput}
                      onChange={(e) =>
                        editmode ? setItemToEdit({...itemToEdit, tag_key: e.target.value}) :
                          setKeyInput(e.target.value)}
                      className="input"
                    />
                  </div>
                  <span>and <b className="text-white">VALUE</b> is </span>
                  <div>
                    <input
                      ref={valueRef}
                      value={editmode ? itemToEdit.tag_value : valueInput}
                      onChange={(e) => editmode ? setItemToEdit({...itemToEdit, tag_value: e.target.value}) : setValueInput(e.target.value)}
                      className="input"
                    />
                  </div>
                </div> : null
              }
              {type === 'NAME_BASED' ?
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <span>If <b className="text-white">{editmode ? 'Resource name' : 'RESOURCE NAME'}</b></span>
                  <div>
                    <Select
                      isClearable={!editmode}
                      options={match_options}
                      value={textMatchType}
                      placeholder="Select match type"
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setTextMatchType(selectedOption);
                          if (editmode) {
                            setItemToEdit({...itemToEdit, matching_pattern: selectedOption.value});
                          }
                        } else {
                          setTextMatchType(null);
                          if (editmode) {
                            setItemToEdit({...itemToEdit, matching_pattern: itemToEdit.matching_pattern});
                          }
                        }
                      }}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                    />

                  </div>
                  <input
                    ref={nameRef}
                    className="input"
                    value={editmode ? itemToEdit.name_pattern : nameInput}
                    onChange={(e) => editmode ? setItemToEdit({...itemToEdit, name_pattern: e.target.value}) : setNameInput(e.target.value)}
                    placeholder="Enter string"
                  />
                </div> : null
              }
            </div>
            {type != null ?
              <div className="w-100 d-flex mt-3">
                <div className="d-flex align-items-center gap-3">
                  <span><b className="text-white">THEN  MAP</b></span>
                  {!editmode ?
                    <div style={{width: "220px"}}>
                      <Select
                        options={autoMappingOptions}
                        value={autoMappingType}
                        onChange={(selectedOption) => {
                          if (selectedOption) {
                            setAutoMappingType(selectedOption)
                          } else {
                            setAutoMappingType(null);
                          }
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      />
                    </div> : null
                  }
                  <span><b className="text-white">TO</b></span>
                  {autoMappingType?.value === 'ApplicationService' || (!editmode && !autoMappingType) ?
                    <div style={{width: "200px"}}>
                      <Select
                        isClearable={!editmode}
                        options={[
                          ...serviceOptions,
                          {value: "/add-service", label: "Add new service"}
                        ]}
                        value={selectedService}
                        placeholder="Select service"
                        onChange={(selectedOption) => {
                          if (selectedOption) {
                            if (selectedOption.value === "/add-service") {
                              window.location.href = "/add-service";
                            }
                            setSelectedService(selectedOption);
                            if (editmode) {
                              setItemToEdit({...itemToEdit, application_service_id: selectedOption.value});
                            }
                          } else {
                            setSelectedService(null);
                            if (editmode) {
                              setItemToEdit({...itemToEdit, application_service_id: itemToEdit.application_service_id});
                            }
                          }
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                        getOptionLabel={(option) => customOptionRenderer(option)}
                      />
                    </div>
                    : null}
                  {autoMappingType?.value === 'Environment' ?
                    <div style={{width: "200px"}}>
                      <Select
                        isClearable={!editmode}
                        options={environments}
                        value={selectedEnv}
                        placeholder="Select environment"
                        onChange={(selectedOption) => {
                          if (selectedOption) {
                            setSelectedEnv(selectedOption);
                            if (editmode) {
                              setItemToEdit({...itemToEdit, environment: selectedOption.value});
                            }
                          } else {
                            setSelectedEnv(null);
                            if (editmode) {
                              setItemToEdit({...itemToEdit, environment: itemToEdit.environment});
                            }
                          }
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      />
                    </div>
                    : null}
                </div>
              </div> : null
            }
            {type != null ?
              <div className="d-flex flex-column w-100 mt-2">
                <div className="d-flex">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-1">
                    <span role="button" onClick={() => setOverrideChecked(!overrideChecked)}>
                      <i className={`bx ${overrideChecked ? 'bxs-checkbox-checked' : 'bx-checkbox'} font-size-24 mt-1`}/>
                    </span>
                      <span>Override mapping</span>
                    </div>
                    <div className="d-flex align-items-center mt-2 gap-1">
                    <span role="button" onClick={() => setCaseInSensitiveChecked(!caseInSensitiveChecked)}>
                      <i className={`bx ${caseInSensitiveChecked ? 'bxs-checkbox-checked' : 'bx-checkbox'} font-size-24 mt-1`}/>
                    </span>
                      <span>Case Insensitive</span>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    disabled={!editmode && isSaveButtonDisabled()}
                    className="btn btn-primary me-2"
                    onClick={() => !editmode ? handleItemAdd() : handleEdit()}>
                    {editmode ? 'Save' : 'Add'}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setIsOpen(false);
                      setEditMode(false);
                      clearInputs();
                    }}>
                    Cancel
                  </button>
                </div>
              </div> : null
            }
          </div>
        </ModalBody>

      </Modal>
      <div className="w-full d-flex justify-content-center">
        <div style={{width: "100%"}}>
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-center align-items-center gap-2 w-50">
              <div>
                <span className="my-4 font-size-20 m-0 font-bold text-white" style={{marginBottom: "0"}}>Service Mapping</span>
                <div className="bg-transparent my-2 mt-1 d-flex" style={{width: "100%"}}>
                  <span className="font-size-12">
                    <b className="font-weight-bold text-warning">Note: </b>
                    <span className="vertical-align-center text-white">Arrange mappings by dragging and dropping the <i className="bx bx-menu font-size-14 mt-2 mb-0"/> icon on the cards to change the order.
                      <span className="text-warning"> The sequence determines the priority.</span></span>
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mb-4 gap-3 align-items-center">
              <span role="button">
                <i id="dndTooltip" className="mdi mdi-information-outline font-size-18 text-success m-0"/>
              </span>
              <Tooltip
                isOpen={tooltipOpen}
                toggle={() => {
                  setTooltipOpen(!tooltipOpen);
                }}
                style={{
                  border: "2px solid whitesmoke",
                  borderRadius: "10px",
                  backgroundColor: "#201a31",
                  zIndex: 1,
                }}
                placement="left"
                target='dndTooltip'
              >
                <div className="d-flex justify-content-center align-items-center">
                  <Lottie
                    loop
                    animationData={dragAndDrop}
                    play
                    style={{width: 80, height: 80}}
                  />
                  <span className="font-size-12">Drag and drop the <i className="bx bx-menu"/> icon on the cards below to change priority.
                  </span>
                </div>
                <span className="font-size-12 text-start mb-5">
                  Make sure to press the
                  <b className="text-success"> Save </b> button to save changes or newly added mappings.
                </span>

              </Tooltip>
              <div className={'d-flex'}>
                <button onClick={() => handleAdd()} className="btn btn-primary">
                  Add new
                </button>
                <button onClick={() => handleMap()} disabled={addMode === false} className="btn btn-success ms-2">
                  Save
                </button>

                <button onClick={() => {
                  setAddMode(false);
                  loadData();
                  resetDataToMap()
                }} disabled={addMode === false} className="btn btn-secondary ms-2">
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    handleClickApplyConfig()
                  }} className="btn btn-secondary ms-2">
                  Apply Now
                </button>
              </div>
            </div>
          </div>
          {loading ?
            <div className="w-full d-flex justify-content-center align-items-center">
              <div role="status" className="ms-2 spinner-border text-primary"><span className="visually-hidden">Loading...</span></div>
            </div> :
            <>
              <div>
                <div className="w-100">
                  <h6 className="font-size-16">Service Mapping Rules</h6>
                  <Table style={{width: '100%', tableLayout: 'fixed'}}>
                    <thead className="text-center m-0 header p-0 ps-1 pe-2"
                           style={{backgroundColor: "#57575752", paddingRight: "10px"}}>
                    <Row>
                      <Col style={{backgroundColor: "transparent"}} lg={1} className="card-col text-white">Type</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={5} className="card-col text-white">Condition</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col text-white">Map to Service</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={1} className="card-col text-white">Override</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col text-white">Case Insensitive</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={1}
                           className="card-col justify-content-start text-white">Actions</Col>
                    </Row>
                    </thead>
                  </Table>
                  <div className="w-100 d-flex flex-column" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                    {(addMode ? dataToMapService : mapped_services)?.filter(item => item.auto_mapping === 'ApplicationService').map((item, index) => (
                      <div draggable
                           ref={index === dataToMap.length - 1 ? newItemRef : null}
                           onDragStart={(e) => allowDrag ? onDragStart(e, `${item.mapping_id || item.id || item.id_to_del}index`) : null}
                           onDragOver={onDragOver}
                           onDrop={(e) => onDrop(e, `${item.mapping_id || item.id || item.id_to_del}index`, item.auto_mapping)}
                           style={{
                             padding: '0',
                             borderRadius: "20px",
                             transition: 'transform 0.7s ease',
                             transform: `translateY(${draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index` ? '10px' : '0'})`,
                           }}

                           key={index}>
                        <Card bg={(draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index` ||
                          hover === (item.mapping_id || item.id || item.id_to_del))
                          ? '#75676d34' : 'inherit'}
                              minHeight="60px"
                              className="w-full d-flex align-items-center justify-content-center pe-1">
                          <Col className="card-col" lg={1}>
                            <span className="font-size-12">{item.mapping_type}</span>
                          </Col>
                          <Col className="card-col justify-content-center mx-2 align-items-center"
                               lg={5}>{item.mapping_type === 'TAG_BASED' ?
                            <div className="d-flex gap-2 align-items-center justify-content-center font-size-12">
                              <span>If</span>
                              <span>tag key:</span>
                              <span id={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white resource-name-truncate"
                                    style={{maxWidth: "40%"}}>{item.tag_key}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}>{item.tag_key}</UncontrolledTooltip>
                              <span>tag value:</span>
                              <span id={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white resource-name-truncate"
                                    style={{maxWidth: "40%"}}>{item.tag_value}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}>{item.tag_value}</UncontrolledTooltip>
                            </div> :
                            <div className="d-flex gap-1 align-items-center justify-content-center">
                              <div className="d-flex gap-1 align-items-center justify-content-center font-size-12">
                                <span>
                                If
                                </span>
                                <span>
                                resource name
                                </span>
                              </div>

                              <span className="input text-white font-size-11">
                                {item.matching_pattern}
                              </span>
                              <span id={`name_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white resource-name-truncate font-size-11"
                                    style={{maxWidth: "40%"}}>{item.name_pattern}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`name_input${item.mapping_id || item.id || item.id_to_del}`}>{item.name_pattern}</UncontrolledTooltip>
                            </div>}
                          </Col>
                          <Col className="card-col" lg={2}>
                            <Link className="resource-name-truncate"
                                  to={`/temperstack-notifications/${item.application_service_id}`}>
                                <span id={`service_name${item.mapping_id || item.id || item.id_to_del}`}
                                      className="font-size-12">{serviceNames[item.application_service_id]}</span>
                            </Link>
                            <UncontrolledTooltip placement="top"
                                                 target={`service_name${item.mapping_id || item.id || item.id_to_del}`}>{serviceNames[item.application_service_id]}</UncontrolledTooltip>
                          </Col>
                          <Col className="card-col" lg={1}>
                            <i
                              id={`status-icon-${item.mapping_id || item.id || item.id_to_del}`}
                              className={`bx ${item.override_existing_mapping ? 'bx-check-circle text-success' : 'bx-x-circle text-warning'} font-size-18`}
                            />
                          </Col>
                          <UncontrolledTooltip
                            target={`status-icon-${item.mapping_id || item.id || item.id_to_del}`}
                            placement="top"
                          >
                            {item.override_existing_mapping ? 'Enabled' : 'Disabled'}
                          </UncontrolledTooltip>
                          <Col className="card-col" lg={2}>
                            <i
                              id={`case-icon-sensitive-${item.mapping_id || item.id || item.id_to_del}`}
                              className={`bx ${item.case_insensitive ? 'bx-check-circle text-success' : 'bx-x-circle text-warning'} font-size-18`}
                            />
                          </Col>
                          <UncontrolledTooltip
                            target={`case-icon-sensitive-${item.mapping_id || item.id || item.id_to_del}`}
                            placement="top"
                          >
                            {item.case_insensitive ? 'Enabled' : 'Disabled'}
                          </UncontrolledTooltip>
                          <Col className="card-col" lg={1}>
                            {!addMode || (addMode && (item.mapping_id === undefined && item.id === undefined)) ?
                              <div className="w-full d-flex gap-2 justify-content-start">
                                  <span id="editBtn" disabled={addMode} role="button" onClick={() => showEditModal({
                                    mapping_type: item.mapping_type,
                                    tag_key: item.tag_key,
                                    tag_value: item.tag_value,
                                    name_pattern: item.name_pattern,
                                    matching_pattern: item.matching_pattern,
                                    mapping_id: item.mapping_id || item.id,
                                    id_to_edit: index,
                                    environment: item?.environment,
                                    application_service_id: item?.application_service_id,
                                    override_existing_mapping: item.override_existing_mapping,
                                    auto_mapping: item.auto_mapping,
                                    case_insensitive: item.case_insensitive
                                  })}>
                                    <i className="mdi mdi-pencil text-success font-size-20"/>
                                  </span>
                                <UncontrolledTooltip placement="top" target={'editBtn'}>Edit
                                  mapping</UncontrolledTooltip>
                                <span id="deleteBtn" disabled={addMode} role="button"
                                      onClick={() => showDeleteModal({
                                        mapping_id: item.id,
                                        id_to_del: item.id_to_del,
                                        auto_mapping: item.auto_mapping
                                      })}>
                                    <i className="mdi mdi-delete text-danger font-size-20"/>
                                  </span>
                                <UncontrolledTooltip placement="top" target={'deleteBtn'}>Delete
                                  mapping</UncontrolledTooltip>

                              </div>
                              : null}
                            <span id="dragBtn2"
                                  style={{
                                    cursor: "grab"
                                  }}
                                  onMouseEnter={() => {
                                    setHover(item.mapping_id || item.id || item.id_to_del);
                                    setAllowDrag(true)
                                  }}
                                  onMouseLeave={() => {
                                    setHover(null);
                                    setAllowDrag(false)
                                  }}
                            >
                                <i className="px-2 mt-1 bx bx-menu font-size-20"/>
                              </span>
                            {hover === item.mapping_id || item.id || item.id_to_del ?
                              <UncontrolledTooltip placement="top" target={'dragBtn2'}>Click and drag to change the
                                order</UncontrolledTooltip>
                              : null
                            }
                          </Col>
                        </Card>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="accordion accordion-flush my-4" id="serviceAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOneService" style={{backgroundColor: "#57575752"}}>
                      <button className="accordion-button collapsed text-white" type="button" data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseOneService" aria-expanded="false"
                              aria-controls="flush-collapseOneService">
                        Service Mapping Rule Recommendations
                      </button>
                    </h2>
                    <div id="flush-collapseOneService" className="accordion-collapse collapse show"
                         aria-labelledby="flush-headingOneService"
                         data-bs-parent="#serviceAccordion">
                      <div className="accordion-body">
                        <div className="w-100">
                          {/*<h6 className="font-size-16">Auto Suggestions for Service Mapping</h6>*/}
                          <Table style={{width: '100%', tableLayout: 'fixed'}}>
                            <thead className="text-center m-0 header p-0 ps-1 pe-2" style={{backgroundColor: "#57575752", paddingRight: "10px"}}>
                            <Row>
                              <Col style={{backgroundColor: "transparent"}} lg={3} className="card-col justify-content-center text-white">Type</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={4} className="card-col justify-content-center text-white">Condition</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={3} className="card-col justify-content-center text-white">Map to Service</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col justify-content-center text-white">Actions</Col>
                            </Row>
                            </thead>
                          </Table>
                          <div className="w-100 d-flex flex-column" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                            {(addMode ? dataToMapService : reorderedMappings)?.filter(item => item.application_mapping_type === 'AS').map((item, index) => (
                              <div key={index}>
                                <Card
                                  bg={((item.auto_mapping === 'ApplicationService' && draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index`) ||
                                    hover === (item.mapping_id || item.id || item.id_to_del))
                                    ? '#75676d34' : 'inherit'}
                                  minHeight="60px"
                                  className="w-full d-flex align-items-center justify-content-center pe-1">
                                  <Col className="card-col" lg={3}>
                                    <span className="font-size-12">NAME_BASED</span>
                                  </Col>
                                  <Col className="card-col justify-content-center mx-2 align-items-center"
                                       lg={4}>{item.mapping_type === 'TAG_BASED' ?
                                    <div
                                      className="d-flex gap-2 align-items-center justify-content-center font-size-12">
                                      <span>If</span>
                                      <span>tag key:</span>
                                      <span id={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                            {item.match_type}
                                          </span>
                                      <UncontrolledTooltip placement="top" target={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.match_string}
                                      </UncontrolledTooltip>
                                      <span>tag value:</span>
                                      <span id={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                            {item.tag_value}
                                          </span>
                                      <UncontrolledTooltip placement="top" target={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.tag_value}
                                      </UncontrolledTooltip>
                                    </div> :
                                    <div className="d-flex gap-1 align-items-center justify-content-center">
                                      <div className="d-flex gap-1 align-items-center justify-content-center">
                                        <span>
                                          If
                                        </span>
                                        <span>
                                          resource name
                                        </span>
                                      </div>
                                      <span className="input text-white font-size-11">
                                            {item.match_type}
                                          </span>
                                      <span id={`name_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white font-size-11 resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                            {item.match_string}
                                          </span>
                                      <UncontrolledTooltip placement="top" target={`name_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.match_string}
                                      </UncontrolledTooltip>
                                    </div>}
                                  </Col>
                                  <Col className="card-col" lg={3}>
                                    <Link className="resource-name-truncate" to={`/temperstack-notifications/${item.application_service_id}`}>
                                        <span id={`service_name${item.mapping_id || item.id || item.id_to_del}`} className="font-size-12">
                                          {serviceNames[item.application_service_id]}
                                        </span>
                                    </Link>
                                    <UncontrolledTooltip placement="top" target={`service_name${item.mapping_id || item.id || item.id_to_del}`}>
                                      {serviceNames[item.application_service_id]}
                                    </UncontrolledTooltip>
                                  </Col>

                                  <Col className="card-col" lg={2}>
                                    {!addMode || (addMode && (item.mapping_id === undefined && item.id === undefined)) ?
                                      <div className="w-full d-flex gap-2 justify-content-start">
                                          <span id={`accept_suggestion_service_${index}`} disabled={addMode} role="button" onClick={() => {
                                            onApproveSuggestion({
                                              suggestion_id: item.id,
                                              is_suggestion_accepted: "ACCEPTED"
                                            })
                                          }}>
                                            <i className="bx bxs-check-circle text-success font-size-24"/>
                                          </span>
                                        <UncontrolledTooltip placement="top" target={`accept_suggestion_service_${index}`}>
                                          Approve Suggestion
                                        </UncontrolledTooltip>
                                        {(item?.is_suggestion_accepted !== 'REJECTED') ? (
                                            <>
                                                      <span id={`ignore_suggestion_service_${index}`} disabled={addMode} role="button"
                                                            onClick={() => {
                                                              onIgnoreSuggestion({
                                                                suggestion_id: item.id,
                                                                is_suggestion_accepted: "REJECTED"
                                                              })
                                                            }}>
                                                        <i className="bx bxs-x-circle text-danger font-size-24"/>
                                                      </span>
                                              <UncontrolledTooltip placement="top" target={`ignore_suggestion_service_${index}`}>
                                                Ignore Suggestion
                                              </UncontrolledTooltip>
                                            </>) :
                                          <>
                                                    <span disabled={true} role="button">
                                                      <i className="bx bx-error text-warning font-size-24"/>
                                                    </span>
                                          </>
                                        }
                                      </div>
                                      : null}
                                  </Col>
                                </Card>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div>
                <div className="w-100">
                  <h6 className="font-size-16">Environment Mapping Rules</h6>
                  <Table style={{width: '100%', tableLayout: 'fixed'}}>
                    <thead className="text-center m-0 header p-0 ps-1 pe-2"
                           style={{backgroundColor: "#57575752", paddingRight: "10px"}}>
                    <Row>
                      <Col style={{backgroundColor: "transparent"}} lg={1} className="card-col text-white">Type</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={5} className="card-col text-white">Condition</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col text-white">Map to Environment</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={1} className="card-col text-white">Override</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col text-white">Case Insensitive</Col>
                      <Col style={{backgroundColor: "transparent"}} lg={1}
                           className="card-col justify-content-start text-white">Actions</Col>
                    </Row>
                    </thead>
                  </Table>
                  <div className="w-100 d-flex flex-column" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                    {(addMode ? dataToMapEnv : mapped_services)?.filter(item => item.auto_mapping === 'Environment').map((item, index) => (
                      <div draggable
                           ref={index === dataToMap.length - 1 ? newItemRef : null}
                           onDragStart={(e) => allowDrag ? onDragStart(e, `${item.mapping_id || item.id || item.id_to_del}index`) : null}
                           onDragOver={onDragOver}
                           onDrop={(e) => onDrop(e, `${item.mapping_id || item.id || item.id_to_del}index`, item.auto_mapping)}
                           style={{
                             padding: '0',
                             borderRadius: "20px",
                             transition: 'transform 0.7s ease',
                             transform: `translateY(${draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index` ? '10px' : '0'})`,
                           }}

                           key={index}>
                        <Card
                          bg={((item.auto_mapping === 'Environment' && draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index`) ||
                            hover === (item.mapping_id || item.id || item.id_to_del))
                            ? '#75676d34' : 'inherit'}
                          minHeight="60px"
                          className="w-full d-flex align-items-center justify-content-center pe-1">
                          <Col className="card-col" lg={1}>
                            <span className="font-size-12">{item.mapping_type}</span>
                          </Col>
                          <Col className="card-col justify-content-center mx-2 align-items-center"
                               lg={5}>{item.mapping_type === 'TAG_BASED' ?
                            <div className="d-flex gap-2 align-items-center justify-content-center font-size-12">
                              <span>If</span>
                              <span>tag key:</span>
                              <span id={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white resource-name-truncate"
                                    style={{maxWidth: "40%"}}>{item.tag_key}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}>{item.tag_key}</UncontrolledTooltip>
                              <span>tag value:</span>
                              <span id={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white resource-name-truncate"
                                    style={{maxWidth: "40%"}}>{item.tag_value}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}>{item.tag_value}</UncontrolledTooltip>
                            </div> :
                            <div className="d-flex gap-1 align-items-center justify-content-center">
                              <div className="d-flex gap-1 align-items-center justify-content-center">
                                <span>
                                If
                                </span>
                                <span>
                                resource name
                                </span>
                              </div>

                              <span className="input text-white font-size-11">
                                {item.matching_pattern}
                              </span>
                              <span id={`name_input${item.mapping_id || item.id || item.id_to_del}`}
                                    className="input text-white font-size-11 resource-name-truncate"
                                    style={{maxWidth: "40%"}}>{item.name_pattern}</span>
                              <UncontrolledTooltip placement="top"
                                                   target={`name_input${item.mapping_id || item.id || item.id_to_del}`}>{item.name_pattern}</UncontrolledTooltip>
                            </div>}
                          </Col>
                          <Col className="card-col font-size-12" lg={2}>{item.environment}</Col>
                          <Col className="card-col" lg={1}>
                            <i
                              id={`status-icon-${item.mapping_id || item.id || item.id_to_del}`}
                              className={`bx ${item.override_existing_mapping ? 'bx-check-circle text-success' : 'bx-x-circle text-warning'} font-size-18`}
                            />
                          </Col>
                          <UncontrolledTooltip
                            target={`status-icon-${item.mapping_id || item.id || item.id_to_del}`}
                            placement="top"
                          >
                            {item.override_existing_mapping ? 'Enabled' : 'Disabled'}
                          </UncontrolledTooltip>
                          <Col className="card-col" lg={2}>
                            <i
                              id={`case-icon-sensitive-${item.mapping_id || item.id || item.id_to_del}`}
                              className={`bx ${item.case_insensitive ? 'bx-check-circle text-success' : 'bx-x-circle text-warning'} font-size-18`}
                            />
                          </Col>
                          <UncontrolledTooltip
                            target={`case-icon-sensitive-${item.mapping_id || item.id || item.id_to_del}`}
                            placement="top"
                          >
                            {item.case_insensitive ? 'Enabled' : 'Disabled'}
                          </UncontrolledTooltip>
                          <Col className="card-col" lg={1}>
                            {!addMode || (addMode && (item.mapping_id === undefined && item.id === undefined)) ?
                              <div className="w-full d-flex gap-2 justify-content-start">
                                  <span id="editBtn" disabled={addMode} role="button" onClick={() => showEditModal({
                                    mapping_type: item.mapping_type,
                                    tag_key: item.tag_key,
                                    tag_value: item.tag_value,
                                    name_pattern: item.name_pattern,
                                    matching_pattern: item.matching_pattern,
                                    mapping_id: item.mapping_id || item.id,
                                    id_to_edit: index,
                                    environment: item?.environment,
                                    application_service_id: item?.application_service_id,
                                    override_existing_mapping: item.override_existing_mapping,
                                    auto_mapping: item.auto_mapping,
                                    case_insensitive: item.case_insensitive
                                  })}>
                                    <i className="mdi mdi-pencil text-success font-size-20"/>
                                  </span>
                                <UncontrolledTooltip placement="top" target={'editBtn'}>Edit
                                  mapping</UncontrolledTooltip>
                                <span id="deleteBtn" disabled={addMode} role="button"
                                      onClick={() => showDeleteModal({
                                        mapping_id: item.id,
                                        id_to_del: item.id_to_del,
                                        auto_mapping: item.auto_mapping
                                      })}>
                                    <i className="mdi mdi-delete text-danger font-size-20"/>
                                  </span>
                                <UncontrolledTooltip placement="top" target={'deleteBtn'}>Delete
                                  mapping
                                </UncontrolledTooltip>

                              </div>
                              : null}
                            <span id='dragBtn'
                                  style={{
                                    cursor: "grab"
                                  }}
                                  onMouseEnter={() => {
                                    setHover(item.mapping_id || item.id || item.id_to_del);
                                    setAllowDrag(true)
                                  }}
                                  onMouseLeave={() => {
                                    setHover(null);
                                    setAllowDrag(false)
                                  }}
                            >
                                <i className="px-2 mt-1 bx bx-menu font-size-20"/>
                              </span>
                            {hover === item.mapping_id || item.id || item.id_to_del ?
                              <UncontrolledTooltip placement="top" target={'dragBtn'}>Click and drag to change the
                                order</UncontrolledTooltip>
                              : null
                            }
                          </Col>
                        </Card>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="accordion accordion-flush my-4" id="environmentAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOneenvironment" style={{backgroundColor: "#57575752"}}>
                      <button className="accordion-button collapsed text-white" type="button" data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseOneenvironment" aria-expanded="false"
                              aria-controls="flush-collapseOneenvironment">
                        Environment Mapping Rule Recommendations
                      </button>
                    </h2>
                    <div id="flush-collapseOneenvironment" className="accordion-collapse collapse" aria-labelledby="flush-headingOneenvironment"
                    >
                      <div className="accordion-body">
                        <div className="w-100">
                          <Table style={{width: '100%', tableLayout: 'fixed'}}>
                            <thead className="text-center m-0 header p-0 ps-1 pe-2" style={{backgroundColor: "#57575752", paddingRight: "10px"}}>
                            <Row>
                              <Col style={{backgroundColor: "transparent"}} lg={3} className="card-col justify-content-center text-white">Type</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={4} className="card-col justify-content-center text-white">Condition</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={3} className="card-col justify-content-center text-white">Map to Environment</Col>
                              <Col style={{backgroundColor: "transparent"}} lg={2} className="card-col justify-content-center text-white">Actions</Col>
                            </Row>
                            </thead>
                          </Table>
                          <div className="w-100 d-flex flex-column" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                            {(addMode ? dataToMapEnv : reorderedMappings)?.filter(item => item.application_mapping_type === 'ENV').map((item, index) => (
                              <div style={{
                                padding: '0',
                                borderRadius: "20px",
                                transition: 'transform 0.7s ease',
                                transform: `translateY(${draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index` ? '10px' : '0'})`,
                              }}
                                   key={index}>
                                <Card
                                  bg={((item.auto_mapping === 'Environment' && draggingCardId === `${item.mapping_id || item.id || item.id_to_del}index`) ||
                                    hover === (item.mapping_id || item.id || item.id_to_del))
                                    ? '#75676d34' : 'inherit'}
                                  minHeight="60px"
                                  className="w-full d-flex align-items-center justify-content-center pe-1">
                                  <Col className="card-col" lg={3}>
                                    <span className="font-size-12">NAME_BASED</span>
                                  </Col>
                                  <Col className="card-col justify-content-center mx-2 align-items-center"
                                       lg={4}>{item.mapping_type === 'TAG_BASED' ?
                                    <div className="d-flex gap-2 align-items-center justify-content-center font-size-12">
                                      <span>If</span>
                                      <span>tag key:</span>
                                      <span id={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                              {item.tag_key}
                                            </span>
                                      <UncontrolledTooltip placement="top" target={`tag_key_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.tag_key}
                                      </UncontrolledTooltip>
                                      <span>tag value:</span>
                                      <span id={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                                {item.tag_value}
                                            </span>
                                      <UncontrolledTooltip placement="top" target={`tag_value_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.tag_value}
                                      </UncontrolledTooltip>
                                    </div> :
                                    <div className="d-flex gap-1 align-items-center justify-content-center">
                                      <div className="d-flex gap-1 align-items-center justify-content-center">
                                                <span>
                                                  If
                                                </span>
                                        <span>
                                                  resource name
                                                </span>
                                      </div>
                                      <span className="input text-white font-size-11">
                                                {item.match_type}
                                             </span>
                                      <span id={`name_input${item.mapping_id || item.id || item.id_to_del}`}
                                            className="input text-white font-size-11 resource-name-truncate"
                                            style={{maxWidth: "40%"}}>
                                                  {item.match_string}
                                             </span>
                                      <UncontrolledTooltip placement="top" target={`name_input${item.mapping_id || item.id || item.id_to_del}`}>
                                        {item.match_string}
                                      </UncontrolledTooltip>
                                    </div>
                                  }
                                  </Col>
                                  <Col className="card-col font-size-12" lg={3}>{item.environment}</Col>
                                  <Col className="card-col" lg={2}>
                                    {!addMode || (addMode && (item.mapping_id === undefined && item.id === undefined)) ?
                                      <div className="w-full d-flex gap-2 justify-content-start">
                                              <span id={`accept_suggestion_${index}`} disabled={addMode} role="button"
                                                    onClick={() => onApproveSuggestion({
                                                      suggestion_id: item.id,
                                                      is_suggestion_accepted: "ACCEPTED"
                                                    })}>
                                                <i className="bx bxs-check-circle text-success font-size-24"/>
                                              </span>
                                        <UncontrolledTooltip placement="top" target={`accept_suggestion_${index}`}>
                                          Approve Suggestion
                                        </UncontrolledTooltip>
                                        {(item?.is_suggestion_accepted !== 'REJECTED') ? (
                                          <>
                                                      <span id={`ignore_suggestion_env_${index}`} disabled={addMode} role="button"
                                                            onClick={() => onIgnoreSuggestion({
                                                              suggestion_id: item.id,
                                                              is_suggestion_accepted: "REJECTED"
                                                            })}>
                                                        <i className="bx bxs-x-circle text-danger font-size-24"/>
                                                      </span>
                                            <UncontrolledTooltip placement="top" target={`ignore_suggestion_env_${index}`}>
                                              Ignore Suggestion
                                            </UncontrolledTooltip>
                                          </>
                                        ) : <>
                                                      <span disabled={true} role="button">
                                                        <i className="bx bx-error text-warning font-size-24"/>
                                                      </span>
                                        </>}
                                      </div>
                                      : null}
                                  </Col>
                                </Card>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default OrganizationServiceMapping;